var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "status-log",
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.359,
    height: 47.721,
    viewBox: "0 0 61.359 47.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1817",
    "data-name": "Group 1817",
    transform: "translate(22.063 33.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1816",
    "data-name": "Group 1816",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_707",
    "data-name": "Path 707",
    d: "M199.487,332.734H185.955a1.852,1.852,0,0,0-1.85,1.85v4.151a1.852,1.852,0,0,0,1.85,1.85h13.533a1.852,1.852,0,0,0,1.85-1.85v-4.151A1.852,1.852,0,0,0,199.487,332.734Zm-.528,5.472H186.483v-3.094h12.476Z",
    transform: "translate(-184.105 -332.734)",
    fill: "#048041"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1819",
    "data-name": "Group 1819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    "data-name": "Group 1818",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M60.757,79.679l.019-.01L51.859,62.04A4.19,4.19,0,0,0,48.1,59.73H46.408V58.091A1.189,1.189,0,0,0,45.219,56.9H16.14a1.189,1.189,0,0,0-1.189,1.189V59.73H13.257A4.19,4.19,0,0,0,9.5,62.04L.583,79.669l.019.01A4.139,4.139,0,0,0,0,81.833v18.624a4.169,4.169,0,0,0,4.165,4.165h53.03a4.169,4.169,0,0,0,4.165-4.165V81.833A4.139,4.139,0,0,0,60.757,79.679ZM46.408,62.372H48.1a1.56,1.56,0,0,1,1.4.86l7.3,14.436H51.838V73.227a1.189,1.189,0,0,0-1.189-1.189H49.178V65.659a1.189,1.189,0,0,0-1.189-1.189H46.408ZM49.46,74.416v3.253H43.185a2.747,2.747,0,0,0-2.5,1.616l-1.713,3.8a.1.1,0,0,1-.092.059h-16.4a.1.1,0,0,1-.092-.059l-1.713-3.8a2.748,2.748,0,0,0-2.5-1.616H11.9V74.416ZM17.329,59.28h26.7v5.19h-26.7ZM46.8,66.848v5.19H14.559v-5.19ZM11.858,63.233a1.56,1.56,0,0,1,1.4-.86h1.695v2.1H13.37a1.189,1.189,0,0,0-1.189,1.189v6.379H10.71a1.189,1.189,0,0,0-1.189,1.189v4.442H4.556ZM57.194,101.98H4.165a1.524,1.524,0,0,1-1.522-1.522V81.833a1.524,1.524,0,0,1,1.522-1.522H18.174a.1.1,0,0,1,.092.059l1.713,3.8a2.747,2.747,0,0,0,2.5,1.616h16.4a2.747,2.747,0,0,0,2.5-1.615l1.713-3.8h0a.1.1,0,0,1,.092-.059H57.194a1.524,1.524,0,0,1,1.522,1.522v18.624h0A1.524,1.524,0,0,1,57.194,101.98Z",
    transform: "translate(0 -56.902)",
    fill: "#048041"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLog);
export default __webpack_public_path__ + "static/media/StatusLog.590c94a6153ad3b0e29c102c0b94b8ba.svg";
export { ForwardRef as ReactComponent };